import React from "react";
import { ArrowRight } from "lucide-react";

export default function QuoteCta({ onRequestQuote }) {
  return (
    <section
      id="contact"
      data-testid="quote-cta"
      className="relative bg-[#0a1a17]"
    >
      <div
        className="absolute inset-0 bg-center bg-cover opacity-50"
        style={{
          backgroundImage: "url('/viewlux/hero/exterior-glass.jpg')",
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-t from-[#0a1a17] via-[#0a1a17]/85 to-[#0a1a17]/70" />

      <div className="relative container-vlx py-28 md:py-40">
        <div className="grid md:grid-cols-12 gap-10 items-end">
          <div className="md:col-span-7">
            <span className="eyebrow eyebrow-light">Begin the Conversation</span>
            <div className="mt-4 rule-gold" />
            <h2 className="heading-lg mt-8 text-white text-[38px] md:text-[72px] leading-[1.02]">
              Tell us your vision.{" "}
              <em className="italic font-light text-[#e2b880]">
                We'll engineer it.
              </em>
            </h2>
          </div>
          <div className="md:col-span-5 md:pl-10">
            <p className="text-white/75 text-[15.5px] leading-[1.95] font-nunito">
              ViewLux serves architects, builders, and homeowners who demand
              quality, value, and reliability. As a direct manufacturer, we
              eliminate dealer markups while providing hands-on project support
              from concept to delivery.
            </p>
            <div className="mt-10 flex flex-wrap gap-4">
              <button
                data-testid="quote-cta-primary"
                onClick={onRequestQuote}
                className="btn-pill btn-primary"
              >
                Request a Consultation
                <ArrowRight className="w-3.5 h-3.5" />
              </button>
              <a
                data-testid="quote-cta-call"
                href="tel:7207703795"
                className="btn-pill btn-outline"
              >
                720.770.3795
              </a>
            </div>
          </div>
        </div>

        {/* Footnote */}
        <div className="mt-20 md:mt-28 pt-8 border-t border-[#c99658]/20 flex flex-col md:flex-row items-start md:items-center justify-between gap-4 text-[11px] tracking-[0.35em] uppercase font-raleway text-[#e2b880]/80">
          <span>Factory direct · Architect-preferred</span>
          <a
            href="https://viewluxwindows.com/"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:text-white transition-colors"
          >
            ViewLux Colorado · viewluxwindows.com ↗
          </a>
        </div>
      </div>
    </section>
  );
}
